import Utils from "../utils/Utils";
export default class Const {
  /** 后端访问地址 */
  public static RemotePath = Utils.getAppServerIP();
  // public static serverApi = "http://pre-pv-admin.zjepd.com/api";
  public static token = "";

  public static SysToken = "";
  public static pointKey = "";
  public static dataType = "1";
  public static selectName = "会议室列表";
  public static isRoam: boolean = false;
}
